// Questo hook è ora deprecato, usa il TranslationContext
import { useTranslations, TranslationProvider } from '../contexts/TranslationContext';

export { useTranslations, TranslationProvider };
export default useTranslations;
